import React from 'react';
import { BrowserRouter as Router } from 'react-router-dom';
import { Provider } from 'react-redux';
import { PersistGate } from 'redux-persist/integration/react';
import { store, persistor } from './redux/store';

import Main from './Main';
import { ApplicationState } from './redux/types';
import configureRequestAuthToken from './redux/reducers/utils/configureRequestAuthToken';
import HydrateUser from './HydrateUser';

/**
 * Handler for once the redux store has been rehydrated from localstorage, but before children are due to be rendered.
 */
function onBeforeLift(): void {
  const { authentication: { authenticationToken } } = store.getState() as unknown as ApplicationState;

  if (authenticationToken) {
    // Update redux-and-the-rest to use the previously stored authentication data for any future requests
    configureRequestAuthToken(authenticationToken);
  }
}

const App: React.FunctionComponent = () => (
  <Provider store={store}>
    <PersistGate persistor={persistor} onBeforeLift={onBeforeLift}>
      <HydrateUser>
        <Router>
          <Main />
        </Router>
      </HydrateUser>
    </PersistGate>
  </Provider>
);

export default App;
